<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.045 0a7.045 7.045 0 0 1 5.639 11.269l3.023 3.024a1 1 0 0 1-1.362 1.463l-.052-.049-3.024-3.023A7.045 7.045 0 1 1 7.045 0zM7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2z" fill="currentColor" fill-rule="nonzero"/>
</svg>
